import { useEffect, useRef } from 'react';

/**
 * Escape closes the topmost overlay only.
 * - A modal (`ref` on an element with aria-modal="true") closes when it is the
 *   last aria-modal element in the document.
 * - A non-modal overlay (side panel) closes only when no aria-modal is open.
 */
export default function useEscape(onClose, { enabled = true, ref = null } = {}) {
  const cb = useRef(onClose);
  cb.current = onClose;
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      const modals = [...document.querySelectorAll('[aria-modal="true"]')];
      if (ref) {
        if (modals[modals.length - 1] !== ref.current) return;
      } else if (modals.length) {
        return;
      }
      e.preventDefault();
      cb.current();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [enabled, ref]);
}
